import ip from 'icepick';
import { ReducerType } from '../types';
import {
  SET_ACTIVE_BOOKING,
  SET_BOOKING_DETAILS,
  SET_PREVIOUS_BOOKING,
  SET_SELECTED_VEHICLE,
  SET_PICK_SLOT,
  SET_SELECTED_PACKAGE,
  SET_PICKUP_LOCATION,
  SET_DROP_LOCATION,
  SET_TRIP_TYPE,
  SET_HAS_TERMS_READ,
} from './type';
import { TripType } from '../constants/Booking';



const initialState: ReducerType = ip.freeze({
  activeBooking: null,
  previousBooking: null,
  bookingDetails: {
    selectedVehicle: {
      vehicleDetails: null,
      transmission: null,
      bodyType: null,
    },
    pickSLot: {
      date: null,
      time: null,
      displayTime: null,
    },
    selectedPackage: null,
    pickupLocation: null,
    dropLocation: null,
    tripType: TripType.OneWayTrip,
    previousBooking: null,
    hasTermsRead: false,
  },
});


const driverOnDemand = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKING_DETAILS: {
      state = ip.setIn(state, ['bookingDetails'], action.payload);
      return state;
    }
    case SET_ACTIVE_BOOKING: {
      state = ip.setIn(state, ['activeBooking'], action.payload);
      return state;
    }
    case SET_PREVIOUS_BOOKING: {
      state = ip.setIn(state, ['previousBooking'], action.payload);
      return state;
    }
    case SET_SELECTED_VEHICLE: {
      state = ip.setIn(
        state,
        ['bookingDetails', 'selectedVehicle'],
        action.payload
      );
      return state;
    }
    case SET_PICK_SLOT: {
      state = ip.setIn(state, ['bookingDetails', 'pickSLot'], action.payload);
      return state;
    }
    case SET_SELECTED_PACKAGE: {
      state = ip.setIn(
        state,
        ['bookingDetails', 'selectedPackage'],
        action.payload
      );
      return state;
    }

    case SET_PICKUP_LOCATION: {
      state = ip.setIn(
        state,
        ['bookingDetails', 'pickupLocation'],
        action.payload
      );
      return state;
    }
    case SET_DROP_LOCATION: {
      state = ip.setIn(
        state,
        ['bookingDetails', 'dropLocation'],
        action.payload
      );
      return state;
    }
    case SET_TRIP_TYPE: {
      state = ip.setIn(state, ['bookingDetails', 'tripType'], action.payload);
      return state;
    }
    case SET_HAS_TERMS_READ: {
      state = ip.setIn(
        state,
        ['bookingDetails', 'hasTermsRead'],
        action.payload
      );
      return state;
    }
    default:
      return state;
  }
};
export default driverOnDemand;
